import configsByCategory from './configs-by-category';
import configsByCategoryForAreaPart from './configs-by-category/commercial-area-parts';
import configsByCategoryCoworking from './configs-by-category/commercial-coworking';

function getRowName(row) {
  if (typeof row === 'string') {
    return row
  } else if (typeof row === 'object') {
    return row.name;
  }
}

function formatRowName(rowName, segment) {
  const parts = rowName.split('/');
  const name = parts.pop();
  const path = parts.join('-') || segment;
  return `cian-af-${path}-${name}`;
}

function getSegment(settings, category) {
  if (settings && settings.isCoworkingEnabled && category === 'officeRent') {
    return configsByCategoryCoworking[settings.coworkingOfferType];
  }

  return configsByCategoryForAreaPart[category] || configsByCategory[category];
}

export default function (category, segment, settings) {
  let result = null;
  const rowsBySegment = getSegment(settings, category);

  if (!rowsBySegment) {
    console.error(`No rows config for category '${category}'`);
  }

  const rows = rowsBySegment[segment];

  if (Array.isArray(rows)) {
    result = rows.map(rowObj => {
        const name = formatRowName(getRowName(rowObj), segment);
        const rowData = typeof rowObj === 'object' ? rowObj : {};

        return {
          ...rowData,
          name,
        };
      });
  }

  return result;
}
